export default __webpack_public_path__ + "static/media/doctorscorner.e87ab843.jpeg";